import { LangType } from '@/app/[lang]/_type/lang';

import { EnumPriceType } from '../core/gql/generated';
import {
    ListingTypeEnum,
    PropertyTypeEnum,
    RentTypeEnum,
} from './property.type';

export const PropertyTypeEnumToText = (
    propertyType: PropertyTypeEnum,
    language: LangType,
): string => {
    if (language === 'id') {
        return {
            [PropertyTypeEnum.allResidential]: 'Residensial',
            [PropertyTypeEnum.house]: 'Rumah',
            [PropertyTypeEnum.apartment]: 'Apartemen',
            [PropertyTypeEnum.shophouse]: 'Ruko',
            [PropertyTypeEnum.land]: 'Tanah',
            [PropertyTypeEnum.factory]: 'Pabrik',
            [PropertyTypeEnum.office]: 'Kantor',
            [PropertyTypeEnum.warehouse]: 'Gudang',
            [PropertyTypeEnum.commercial]: 'Ruang Usaha',
            [PropertyTypeEnum.kost]: 'Kost',
            [PropertyTypeEnum.villa]: 'Villa',
            [PropertyTypeEnum.hotel]: 'Hotel',
            [PropertyTypeEnum.newLaunch]: '',
        }[propertyType];
    }

    return {
        [PropertyTypeEnum.allResidential]: 'All Residential',
        [PropertyTypeEnum.house]: 'House',
        [PropertyTypeEnum.apartment]: 'Apartment',
        [PropertyTypeEnum.shophouse]: 'Shophouse',
        [PropertyTypeEnum.land]: 'Land',
        [PropertyTypeEnum.factory]: 'Factory',
        [PropertyTypeEnum.office]: 'Office Space',
        [PropertyTypeEnum.warehouse]: 'Warehouse',
        [PropertyTypeEnum.commercial]: 'Commercial Space',
        [PropertyTypeEnum.kost]: 'Kost',
        [PropertyTypeEnum.villa]: 'Villa',
        [PropertyTypeEnum.hotel]: 'Hotel',
        [PropertyTypeEnum.newLaunch]: '',
    }[propertyType];
};

export const PropertyTypeIdToEnum = (
    propertyType: string,
): PropertyTypeEnum | undefined => {
    return {
        ['15']: PropertyTypeEnum.allResidential,
        ['0']: PropertyTypeEnum.house,
        ['1']: PropertyTypeEnum.apartment,
        ['2']: PropertyTypeEnum.shophouse,
        ['5']: PropertyTypeEnum.land,
        ['11']: PropertyTypeEnum.factory,
        ['7']: PropertyTypeEnum.office,
        ['8']: PropertyTypeEnum.warehouse,
        ['4']: PropertyTypeEnum.commercial,
        ['6']: PropertyTypeEnum.kost,
        ['3']: PropertyTypeEnum.villa,
        ['9']: PropertyTypeEnum.hotel,
        ['16']: PropertyTypeEnum.newLaunch,
    }[propertyType];
};

export const PropertyTypeTextToEnum = (
    propertyType: string,
): PropertyTypeEnum => {
    return (
        {
            'All Residential': PropertyTypeEnum.allResidential,
            Apartemen: PropertyTypeEnum.apartment,
            Apartment: PropertyTypeEnum.apartment,
            'Commercial Space': PropertyTypeEnum.commercial,
            Factory: PropertyTypeEnum.factory,
            Gudang: PropertyTypeEnum.warehouse,
            gudang: PropertyTypeEnum.warehouse,
            House: PropertyTypeEnum.house,
            Kantor: PropertyTypeEnum.office,
            kantor: PropertyTypeEnum.office,
            Land: PropertyTypeEnum.land,
            'Office Space': PropertyTypeEnum.office,
            Pabrik: PropertyTypeEnum.factory,
            pabrik: PropertyTypeEnum.factory,
            Residensial: PropertyTypeEnum.allResidential,
            'Ruang Usaha': PropertyTypeEnum.commercial,
            'ruang-usaha': PropertyTypeEnum.commercial,
            Ruko: PropertyTypeEnum.shophouse,
            ruko: PropertyTypeEnum.shophouse,
            Rumah: PropertyTypeEnum.house,
            Shophouse: PropertyTypeEnum.shophouse,
            Tanah: PropertyTypeEnum.land,
            Warehouse: PropertyTypeEnum.warehouse,
            apartemen: PropertyTypeEnum.apartment,
            hotel: PropertyTypeEnum.hotel,
            kost: PropertyTypeEnum.kost,
            rumah: PropertyTypeEnum.house,
            tanah: PropertyTypeEnum.land,
            villa: PropertyTypeEnum.villa,
        }[propertyType] || PropertyTypeEnum.house
    );
};

export const PriceTypeTextToEnum = (priceType: string): EnumPriceType => {
    return (
        {
            Dijual: EnumPriceType.Sale,
            Disewa: EnumPriceType.Rent,
            Rent: EnumPriceType.Rent,
            Sale: EnumPriceType.Sale,
            dijual: EnumPriceType.Sale,
            disewa: EnumPriceType.Rent,
            jual: EnumPriceType.Sale,
            rent: EnumPriceType.Rent,
            sale: EnumPriceType.Sale,
            sewa: EnumPriceType.Rent,
        }[priceType] || EnumPriceType.Sale
    );
};

export const PriceTypeTextToEnumNumber = (
    priceType: string,
): ListingTypeEnum => {
    return (
        {
            Dijual: ListingTypeEnum.sale,
            Disewa: ListingTypeEnum.rent,
            Rent: ListingTypeEnum.rent,
            Sale: ListingTypeEnum.sale,
            dijual: ListingTypeEnum.sale,
            disewa: ListingTypeEnum.rent,
            jual: ListingTypeEnum.sale,
            rent: ListingTypeEnum.rent,
            sale: ListingTypeEnum.sale,
            sewa: ListingTypeEnum.rent,
        }[priceType] || ListingTypeEnum.sale
    );
};

export const PriceTypeEnumToText = (
    listingType: EnumPriceType,
    language: LangType,
): string => {
    if (language === 'id') {
        return {
            [EnumPriceType.Sale]: 'Dijual',
            [EnumPriceType.Rent]: 'Disewa',
        }[listingType];
    }

    return {
        [EnumPriceType.Sale]: 'Sale',
        [EnumPriceType.Rent]: 'Rent',
    }[listingType];
};

export const PriceTypeSearchParamToText = (
    listingType: string,
    language: LangType,
): string => {
    if (language === 'id') {
        return (
            {
                jual: 'Dijual',
                sewa: 'Disewa',
            }[listingType] || 'Dijual'
        );
    }

    return (
        {
            jual: 'Sale',
            sewa: 'Rent',
        }[listingType] || 'Sale'
    );
};

export const propertyTypeEnumToUrl = (
    listingType: PropertyTypeEnum,
    lang: LangType,
) => {
    if (lang === 'id') {
        const mapping = {
            [PropertyTypeEnum.allResidential]: '',
            [PropertyTypeEnum.house]: 'rumah',
            [PropertyTypeEnum.apartment]: 'apartemen',
            [PropertyTypeEnum.shophouse]: 'ruko',
            [PropertyTypeEnum.land]: 'tanah',
            [PropertyTypeEnum.factory]: 'pabrik',
            [PropertyTypeEnum.office]: 'kantor',
            [PropertyTypeEnum.warehouse]: 'gudang',
            [PropertyTypeEnum.commercial]: 'ruang-usaha',
            [PropertyTypeEnum.kost]: 'kost',
            [PropertyTypeEnum.villa]: 'villa',
            [PropertyTypeEnum.hotel]: 'hotel',
            [PropertyTypeEnum.newLaunch]: '',
        };
        return mapping[listingType] || '';
    }
    const mapping = {
        [PropertyTypeEnum.allResidential]: '',
        [PropertyTypeEnum.house]: 'house',
        [PropertyTypeEnum.apartment]: 'apartment',
        [PropertyTypeEnum.shophouse]: 'shophouse',
        [PropertyTypeEnum.land]: 'land',
        [PropertyTypeEnum.factory]: 'factory',
        [PropertyTypeEnum.office]: 'office',
        [PropertyTypeEnum.warehouse]: 'gudang',
        [PropertyTypeEnum.commercial]: 'commercial',
        [PropertyTypeEnum.kost]: 'kost',
        [PropertyTypeEnum.villa]: 'villa',
        [PropertyTypeEnum.hotel]: 'hotel',
        [PropertyTypeEnum.newLaunch]: '',
    };
    return mapping[listingType] || '';
};

export const PriceTypeSearchParamToUrl = (
    listingType: string,
    language: LangType,
): string | undefined => {
    if (language === 'id') {
        return {
            '0': 'jual',
            '1': 'sewa',
            jual: 'jual',
            sewa: 'sewa',
            'perumahan-baru': 'perumahan-baru',
        }[listingType];
    }

    return {
        '0': 'sale',
        '1': 'rent',
        jual: 'sale',
        sewa: 'rent',
        'perumahan-baru': 'new-launch',
    }[listingType];
};

export const priceTypeTextToUrl = (
    listingType: string,
    language: LangType,
): string | undefined => {
    if (language === 'id') {
        return {
            jual: 'jual',
            sewa: 'sewa',
            sale: 'jual',
            rent: 'sewa',
        }[listingType];
    }

    return {
        jual: 'sale',
        sewa: 'rent',
        sale: 'sale',
        rent: 'rent',
    }[listingType];
};

export const RentTypeEnumToText = (
    rentType: RentTypeEnum,
    language: LangType,
): string => {
    if (language === 'id') {
        return {
            [RentTypeEnum.Daily]: 'Harian',
            [RentTypeEnum.Weekly]: 'Mingguan',
            [RentTypeEnum.Monthly]: 'Bulanan',
            [RentTypeEnum.Yearly]: 'Tahunan',
        }[rentType];
    }

    return {
        [RentTypeEnum.Daily]: 'Daily',
        [RentTypeEnum.Weekly]: 'Weekly',
        [RentTypeEnum.Monthly]: 'Monthly',
        [RentTypeEnum.Yearly]: 'Yearly',
    }[rentType];
};
